import * as helper from '@/store/helpers'
import { defineStore } from 'pinia'

export const useResourcesStore = defineStore('resources', {
    state() {
        return {
            allResources: [],
            resourcesTags: []
        }
    },
    actions: {
        async getResources(
            start,
            end,
            searchString = '',
            tagsId = [],
            isDesc = true
        ) {
            const data = {
                start,
                end,
                search_string: searchString,
                tags_id: tagsId,
                is_desc: isDesc
            }

            this.allResources = await helper.api('GET', '/resources', data)
        },

        async getResourcesTags(hasSubTags) {
            const data = {
                with_tags: hasSubTags
            }

            this.resourcesTags = await helper.api(
                'GET',
                '/resources/main_tag',
                data
            )
        }
    },
    getters: {
        formatResourcesTags(state) {
            const result = []
            const data = state.resourcesTags
            for (const category of data) {
                result.push({
                    id: category.id,
                    title: category.name,
                    filters: category.tags.map((elem) => {
                        return {
                            id: elem.id,
                            mainTagId: elem.resource_main_tag_id,
                            title: elem.year
                        }
                    })
                })
            }

            return result
        }
    }
})
